/** Static Figma Admin Settings fixtures (`40005323:56009`, `40005331:56960`, `40005345:46221`). */

export const SETTINGS_TABS = [
  { key: "profile", label: "Profile Settings" },
  { key: "notifications", label: "Notifications" },
]

export const DEFAULT_PROFILE = {
  firstName: "Jerry",
  lastName: "Micheal",
  location: "Dallas, TX",
  email: "jerry.m@amok.earth",
  phone: "+1 (214) 555-0199",
  twoFactorEnabled: false,
}

export const NOTIFICATION_SECTIONS = [
  {
    key: "notifications",
    title: "Notifications",
    items: [
      {
        key: "inAppNotification",
        label: "In-app Notification",
        description: "Receive notifications inside the app",
        defaultEnabled: true,
      },
      {
        key: "pushNotification",
        label: "Push Notification",
        description: "Receive push notifications on your devices",
        defaultEnabled: true,
      },
    ],
  },
  {
    key: "email",
    title: "Email",
    items: [
      {
        key: "emailNotification",
        label: "Email",
        description: "Receive notifications by email",
        defaultEnabled: true,
      },
    ],
  },
]

export const buildDefaultNotificationPrefs = (sections = NOTIFICATION_SECTIONS) => {
  const prefs = {}

  sections.forEach(section => {
    section.items.forEach(item => {
      prefs[item.key] = item.defaultEnabled
    })
  })

  return prefs
}

/** Map GET /api/v1/user/notification-settings → UI toggle keys. */
export const mapNotificationSettingsFromApi = (result = {}) => ({
  inAppNotification: Boolean(result.in_app),
  pushNotification: Boolean(result.push),
  emailNotification: Boolean(result.email),
})

/** Map UI toggles → PATCH /api/v1/user/notification-settings body. */
export const mapNotificationSettingsToApi = (prefs = {}) => ({
  in_app: Boolean(prefs.inAppNotification),
  push: Boolean(prefs.pushNotification),
  email: Boolean(prefs.emailNotification),
})
